import { withFieldServerErrors } from '@perpay-web/components/higher-order/WithFieldServerErrors/WithFieldServerErrors';
import { CompanyPickerContainerV2 } from '@perpay-web/fintech/components/containers/CompanyPickerContainer';

const CompanyPickerServerError = withFieldServerErrors(
    CompanyPickerContainerV2,
);

export default CompanyPickerServerError;
